// @flow
import queryString from 'query-string';
import { trackUserEvent, utmSourcesToTrack } from 'api/trackedUserEvents';

export const trackReferrals = () => {
  const queryParams = queryString.parse(window.location.search);
  const utmSource = queryParams.utm_source;
  const utmSources = Array.isArray(utmSource) ? utmSource : [utmSource];
  utmSources.forEach(u => {
    switch (utmSourcesToTrack[u]) {
      case 'JAZZHR_REFERRAL':
        trackUserEvent({
          eventName: 'JAZZHR_REFERRAL',
          extraData: { url: window.location.href }
        });
        break;
      default:
        break;
    }
  });
};
